var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 68.693333a160 160 0 0 1 48.768 7.616l277.333333 88.746667A160 160 0 0 1 693.333333 317.44v146.922667l87.125334-55.424a96 96 0 0 1 129.856 25.472l2.666666 3.968a96 96 0 0 1 15.018667 51.541333V896h21.333333a32 32 0 0 1 0 64h-874.666666a32 32 0 0 1 0-64h21.333333V228.693333a160 160 0 0 1 154.816-159.914666z m0 64a96 96 0 0 0-96 96V896h469.333333V317.44a96 96 0 0 0-62.378666-89.92l-4.373334-1.514667-277.333333-88.746666A96 96 0 0 0 256 132.693333z m602.986667 340.053334a32 32 0 0 0-44.16-9.813334L693.333333 540.224V896h170.666667V489.92a32 32 0 0 0-3.221333-14.016zM288 533.333333a32 32 0 0 1 32 32v106.666667a32 32 0 0 1-64 0v-106.666667a32 32 0 0 1 32-32z m0-256a32 32 0 0 1 32 32v106.666667a32 32 0 0 1-64 0v-106.666667a32 32 0 0 1 32-32z",
    fill: "#5b0f8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/apartment.e8e332fe652c837a0180cb6910ed03a1.svg";
export { ForwardRef as ReactComponent };